export interface VisibilityRule {
  id: number;
  name: string;
  description?: string;
}

export interface VisibilityRuleDropDownItems {
  value: number;
  label: string;
}

export interface CurrentUserVisibilityRuleAccess {
  hasGlobalVisibility?: boolean;
  hasUserOnly?: boolean;
  hasUserAndParentOnly?: boolean;
  hasUserAndParentGroup?: boolean;
  hasFullHierarchy?: boolean;
  hasClientCustomer?: boolean;
}


export const VisibilityRulesKey = 'visibility-rule';
export const CurrentUserVisibilityRuleKey = 'current-user-visibility-rule';